import { useState } from "react";

const MaterialDropDown = (props) => {

    var val = props.defaultValue
    const options = ['Gold', 'Silver','Ratios']

    const [oldValue, setOldValue] = useState(val);

    const fnChange = (e) => {
        setOldValue(e.target.value);
        props.handleChange(e.target.value, oldValue);
    }

    return (
        <select  className = "form-control gold-silver" defaultValue={val}
        onChange={fnChange}>
            {options.map((item,key) => {
                if(props.chart_name !== "ratios_chart" && item === "Ratios")
                    return null
                return <option key={key}>{item}</option>
            })}
        </select>
    )
}

export default MaterialDropDown;